import React from 'react';
import { motion } from 'framer-motion';
import { FaLinkedin } from 'react-icons/fa';

const LeadershipPage = () => {
    const leaders = [
        {
            name: 'Rajesh Kumar',
            title: 'Chief Executive Officer',
            desc: '25+ years driving digital transformation across Fortune 500 companies',
            image: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400',
            linkedin: '#'
        },
        {
            name: 'Priya Sharma',
            title: 'Chief Technology Officer',
            desc: 'Technology visionary with expertise in AI, cloud, and enterprise architecture',
            image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400',
            linkedin: '#'
        },
        {
            name: 'Amit Patel',
            title: 'Chief Operating Officer',
            desc: 'Operations excellence leader focused on delivery and client success',
            image: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=400',
            linkedin: '#'
        },
        {
            name: 'Neha Gupta',
            title: 'Chief Financial Officer',
            desc: 'Strategic financial planning and growth enabler for global operations',
            image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400',
            linkedin: '#'
        },
        {
            name: 'Vikram Singh',
            title: 'Chief Innovation Officer',
            desc: 'Innovation catalyst driving R&D and next-gen technology adoption',
            image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400',
            linkedin: '#'
        },
        {
            name: 'Ananya Desai',
            title: 'Chief People Officer',
            desc: 'Building world-class teams and fostering culture of excellence',
            image: 'https://images.unsplash.com/photo-1594744803329-e58b31de8bf5?w=400',
            linkedin: '#'
        }
    ];

    return (
        <div className="bg-white font-sans">
            <section className="relative bg-gradient-to-br from-slate-800 via-gray-800 to-zinc-900 text-white pt-24 pb-16 overflow-hidden">
                <div className="absolute inset-0 opacity-20">
                    <div className="absolute inset-0" style={{
                        backgroundImage: 'radial-gradient(circle at 20% 50%, rgba(120,119,198,0.3), transparent 50%), radial-gradient(circle at 80% 80%, rgba(99,102,241,0.3), transparent 50%)',
                    }}></div>
                </div>
                <div className="max-w-7xl mx-auto px-6 lg:px-12 relative z-10">
                    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
                        <p className="text-sm font-light tracking-widest uppercase text-gray-300 mb-3">Who We Are</p>
                        <h1 className="text-5xl md:text-6xl font-light mb-4 leading-tight">Leadership</h1>
                        <p className="text-lg font-light text-gray-200 leading-relaxed max-w-2xl">Meet the visionaries driving our mission to transform businesses through technology</p>
                    </motion.div>
                </div>
            </section>

            <section className="py-16 bg-slate-50">
                <div className="max-w-7xl mx-auto px-6 lg:px-12">
                    <div className="max-w-4xl">
                        <h2 className="text-3xl font-light text-slate-900 mb-6">Experienced. Visionary. Committed.</h2>
                        <p className="text-lg text-slate-600 leading-relaxed mb-4">Our leadership team brings together decades of experience in technology, business transformation, and innovation.</p>
                        <p className="text-lg text-slate-600 leading-relaxed">United by a shared vision, they guide Tech Inovant in delivering exceptional value to clients worldwide.</p>
                    </div>
                </div>
            </section>

            <section className="py-16 bg-white">
                <div className="max-w-7xl mx-auto px-6 lg:px-12">
                    <h2 className="text-3xl font-light text-slate-900 mb-12">Executive Team</h2>
                    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                        {leaders.map((leader, idx) => (
                            <motion.div
                                key={idx}
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ delay: idx * 0.1 }}
                                className="group relative overflow-hidden rounded-sm border border-slate-200 bg-white hover:shadow-xl transition-all"
                            >
                                <div className="relative h-80 overflow-hidden">
                                    <img
                                        src={leader.image}
                                        alt={leader.name}
                                        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                                    />
                                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div>

                                    {/* Info overlay - always visible at bottom */}
                                    <div className="absolute bottom-0 left-0 right-0 p-6 text-white z-10">
                                        <h3 className="text-xl font-medium mb-1">{leader.name}</h3>
                                        <p className="text-sm text-gray-300 mb-4">{leader.title}</p>

                                        {/* Hover reveal */}
                                        <motion.div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-indigo-600 to-purple-600 p-6 transform translate-y-full group-hover:translate-y-0 transition-transform duration-500">
                                            <p className="text-white text-sm leading-relaxed mb-4">{leader.desc}</p>
                                            <a href={leader.linkedin} className="inline-flex items-center text-white font-medium hover:underline">
                                                <FaLinkedin className="mr-2" /> Connect on LinkedIn
                                            </a>
                                        </motion.div>
                                    </div>
                                </div>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </section>

            <section className="py-16 bg-gradient-to-r from-slate-800 to-gray-900 text-white">
                <div className="max-w-4xl mx-auto px-6 lg:px-12 text-center">
                    <h2 className="text-3xl md:text-4xl font-light mb-6">Join Our Team</h2>
                    <p className="text-lg font-light mb-8 text-gray-300">Be part of a team that's shaping the future of technology</p>
                    <a href="/careers" className="inline-block px-8 py-3 bg-white text-slate-800 font-medium rounded-sm hover:shadow-xl transition-all">View Careers</a>
                </div>
            </section>
        </div>
    );
};

export default LeadershipPage;
